import { jsxs, jsx } from 'react/jsx-runtime';
import { SVG } from './utils/style.svg.js';
import { getDefaultHeight } from './utils/get-default-height.js';

const RetryIcon = ({
  color,
  ...svgProps
}) => {
  return /*#__PURE__*/jsxs(SVG, {
    viewBox: "0 0 19 22",
    xmlns: "http://www.w3.org/2000/svg",
    height: getDefaultHeight(svgProps, 22),
    ...svgProps,
    fill: svgProps.fill ?? "none",
    stroke: color ?? svgProps.stroke ?? "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [/*#__PURE__*/jsx("path", {
      d: "M5.86 1 1.8 4.85l4.05 3.84"
    }), /*#__PURE__*/jsx("path", {
      d: "M1 12.92c0 1.6.5 3.16 1.43 4.49a8.42 8.42 0 0 0 3.82 2.98c1.55.6 3.26.77 4.9.45a8.65 8.65 0 0 0 4.36-2.2 7.96 7.96 0 0 0 2.33-4.14 7.7 7.7 0 0 0-.49-4.67 8.18 8.18 0 0 0-3.13-3.62A8.82 8.82 0 0 0 9.5 4.85H1.81"
    })]
  });
};

export { RetryIcon };
//# sourceMappingURL=retry.js.map
